import docCookies from './docCookies';
import Crypto from 'crypto';

// 获取主域名
const getDomain = () => {
  let domain = '';
  if (/localhost/.test(location.hostname)) {
    domain = 'localhost';
  } else {
    // eslint-disable-next-line no-useless-escape
    domain = location.hostname.replace(/(\w+\.)?(\w+\.\w+)(\:\d+)?$/i, '$2');
  }
  return domain;
}
// 参数转换成字符串
const strify = arg => {
  if (arg === undefined) return "";
  if (arg.constructor != Object) return arg.toString();
  return JSON.stringify(arg);
}
// 需要同步到 Cookie 中的 Key 数组
const SYNC_TO_COOKIE = ["token", "refresh_token"];

// 将指定的K-V设置到本地存储中
const setItem = (key, value) => {
  localStorage.setItem(key, strify(value));
  if (SYNC_TO_COOKIE.indexOf(key) != -1) {
    let domain = getDomain();
    docCookies.setItem(key, value, Infinity, '/', domain);
  }
}
// 获取本地存储中指定的项
const getItem = key => {
  return localStorage.getItem(key) || docCookies.getItem(key);
}
// 检查本地存储是是否含有指定的项
const hasItem = key => !!getItem(key);

// 从本地存储中移除指定的项
const removeItem = key => {
  localStorage.removeItem(key);
  let domain = getDomain();
  docCookies.removeItem(key, '/', domain);
}

// 获取本地购物车数据
const getCartInfo = () => {
  let localCart = getItem('localCart') || {
    goods_list: {
      goods: [],
      free_try: [],
    },
    total: {
      total_product_price: 0,
      total_discount: 0,
      total_used_points: 0,
      total_ship_fee: 0,
      total_wrap_fee: 0,
      total_amount: 0
    }
  };
  // 字符串转对象
  if (typeof localCart === 'string') {
    localCart = JSON.parse(localCart);
  }
  return localCart;
}

// 设置本地购物车数据
const setCartInfo = arg => {
  let { goods_list, total } = arg;
  if (Array.isArray(goods_list?.goods) && total?.total_amount != undefined) {
    setItem('localCart', JSON.stringify(arg));
  } else {
    console.warn('setCartInfo: 数据格式不正确');
  }
}

// 添加商品到本地购物车中
const addToCart = (params, callback) => {
  let { id, quantity, price, selected } = params;
  if (!id || !price || isNaN(price) || !quantity || isNaN(quantity)) {
    console.warn(`addToCart: 参数不完整或参数错误({id: ${id}, price: ${price}, quantity: ${quantity}})`);
    return false;
  }
  // 
  let localCart = getCartInfo();
  let errMsg;
  // 查找是否存在相同规格的商品
  // let oldItem = null;
  // localCart.goods_list.goods.forEach(outerItem => {
  //   if (outerItem?.main?.length) {
  //     oldItem = outerItem.main.find(innerItem => innerItem.id == id); // unique_id
  //   }
  // })
  let oldItem = localCart.goods_list.goods.find(item => item.id == id);
  // 存在则更新数量，否则添加进本地存储
  if (oldItem) {
    // 
    if (oldItem.quantity >= 6) {
      errMsg = "相同的商品最多可购买6件";
      isFunction(callback) && callback(localCart, errMsg);
      return false;
    }
    // 原来的商品小计
    let oMoney = oldItem.quantity * oldItem.price;
    // 更新商品属性
    oldItem.price = price;
    oldItem.quantity = parseInt(oldItem.quantity) + parseInt(quantity);
    if (oldItem.quantity > 6) oldItem.quantity = 6;
    // 新的商品小计
    let nMoney = oldItem.quantity * oldItem.price;
    // 更新购物车小计、合计
    localCart.total.total_product_price = localCart.total.total_product_price - oMoney + nMoney;
    localCart.total.total_amount = localCart.total.total_amount - oMoney + nMoney;
  } else {
    // 
    params.selected = selected != undefined ? selected : true;
    // 
    // if (params.quantity > 6) {
    //   params.quantity = 6;
    //   errMsg = "相同的商品最多可购买6件";
    // }
    //
    localCart.goods_list.goods.push(params);
    // 商品小计
    let nMoney = Math.min(parseInt(quantity), 6) * price;
    // 更新购物车小计、合计
    localCart.total.total_product_price += nMoney;
    localCart.total.total_amount += nMoney;
  }
  // 更新本地存储
  setCartInfo(localCart);
  // 
  isFunction(callback) && callback(localCart, errMsg);
  // 
  return true;
}

// 删除本地购物车中指定商品
const delCart = (id, callback) => {
  if (!id) return console.warn(`delCart: 参数不完整或参数错误({ID ${id}})`), false;
  // 
  let localCart = getCartInfo();
  // 查找是否存在相同ID的商品
  let oIdx = localCart.goods_list.goods.findIndex(item => item.id == id); // unique_id
  if (oIdx != -1) {
    let oldItem = localCart.goods_list.goods[oIdx];
    // 原来的商品小计
    let oldMoney = parseFloat(oldItem.price) * parseInt(oldItem.quantity);
    // 
    localCart.goods_list.goods.splice(oIdx, 1);
    // 更新小计、合计
    localCart.total.total_product_price -= oldMoney;
    localCart.total.total_amount -= oldMoney;
    // 更新本地存储
    setCartInfo(localCart);
    // 
    isFunction(callback) && callback(localCart);
    // 
    return true;
  } else {
    console.warn(`localCart中不存在指定 SKU_ID（${id}） 的商品`);
    return false;
  }
}

// 更新本地购物车中指定商品
const updateCart = (params, callback) => {
  let { oid, nid, price, quantity, selected } = params;
  if (!oid || !nid || !price || isNaN(price) || !quantity || isNaN(quantity)) {
    console.warn(`updateCart: 参数不完整或参数错误({OldId: ${oid}, NewId: ${nid}, price: ${price}, quantity: ${quantity}})`);
    return false;
  }
  // ID 不一致则先删除再添加
  if (oid != nid) {
    // 更新的状态
    let updateRet = false;
    // 
    let delRet = delCart(oid);
    if (delRet) {
      let addRet = addToCart({ id: nid, quantity, price, selected });
      updateRet = addRet;
    } else {
      updateRet = delRet;
    }
    let localCart = getCartInfo();
    // 
    isFunction(callback) && callback(localCart);
    // 
    return updateRet;
  } else {
    // 
    let localCart = getCartInfo();
    // 查找是否存在相同ID的商品
    let item = localCart.goods_list.goods.find(item => item.id == nid);
    if (item) {
      // 计算新旧小计
      let oMoney = parseFloat(item.price) * parseInt(item.quantity);
      let nMoney = parseFloat(price) * parseInt(quantity);
      // 更新属性
      item.price = price;
      item.quantity = quantity;
      item.selected = selected != undefined ? !!selected : true;
      // 
      localCart.total.total_product_price = localCart.total.total_product_price - oMoney + nMoney;
      localCart.total.total_amount = localCart.total.total_amount - oMoney + nMoney;
      // 
      setCartInfo(localCart)
      // 
      isFunction(callback) && callback(localCart);
      // 
      return true;
    } else {
      console.warn(`updateCartItemCount: 找不到符合条件的记录（SKU-ID=${nid}）`);
      return false;
    }
  }
}

// 更新本地购物车条目的选中状态
const setCartItemSelected = (ids, state, callback) => {
  if (!Array.isArray(ids) || !ids.length) return console.warn(`setCartItemSelected: 参数不完整或参数错误({ID ${ids}})`), false;
  // 
  let localCart = getCartInfo();
  // 
  ids.forEach(id => {
    // 查找是否存在相同ID的商品
    let idx = localCart.goods_list.goods.findIndex(item => item.id == id); // unique_id
    if (idx != -1) {
      let item = localCart.goods_list.goods[idx];
      item.selected = state != undefined ? !!state : true;
    } else {
      console.warn(`localCart中不存在指定 SKU_ID（${id}） 的商品`);
      return false;
    }
  });
  // 更新本地存储
  setCartInfo(localCart);
  // 
  isFunction(callback) && callback(localCart);
  // 
  return true;
}

// 更新本地购物车免费试用商品选中状态
const updateFreeTrialStatus = (params, callback) => {
  let { id, state } = params;
  if (id != undefined && state != undefined) {
    let localCart = getCartInfo();
    let oIndex = localCart.goods_list.free_try.findIndex(item => item.id == id);

    if (oIndex != -1) {
      let oItem = localCart.goods_list.free_try[oIndex];
      if (!state) {
        localCart.goods_list.free_try.splice(oIndex, 1);
      } else if (!oItem.state) {
        oItem.state = state;
      }
    } else if (state) {
      localCart.goods_list.free_try.push({ id, state });
    }
    setCartInfo(localCart);
    isFunction(callback) && callback();
  } else {
    console.warn('localCart::试用装数据异常', params);
  }
}
/* 更新本地购物车 spa/服务 选中状态 */
const updateSpaAndTryStatus=(params,callback)=>{
	// 未完成 暂无此需求
	return;
	let localCart = getCartInfo();
	console.log(params)
	if(!localCart.spa_try){
		localCart.spa_try=[];
	}
	// [flag: 1,id: "SPA2",rule_id: 861 type: "spa_try"]
	// id 不能确保唯一
	for(let i=0;i<localCart.spa_try.length;i++){
		let titem=localCart.spa_try[i]
		// 选中 并已经存在
		if(params.flag==1&&params.type==titem.type&&params.rule_id==titem.rule_id&&params.id==titem.id){
			return;
		}
		// 未选中并不存在
		if(params.flag==0&&!(params.type==titem.type&&params.rule_id==titem.rule_id&&params.id==titem.id)){
			return;
		}
		// 未选中 存在
		if(params.flag==0&&(params.type==titem.type&&params.rule_id==titem.rule_id&&params.id==titem.id)){
			console.log("未选中存在")
			localCart.spa_try.splice(i, 1)
			break;
		}
	}
	// 选中 不存在
	if(params.flag==1){
		localCart.spa_try.push(params)
	}
	console.log(localCart.spa_try)
	setCartInfo(localCart);
	return;
	isFunction(callback) && callback();
}
// 清空本地购物车的数据
const clearCart = confirm => {
  confirm && removeItem('localCart');
  return !!confirm;
}


// 下单成功更新本地购物车
const updateOrderCart= () => {
  let localCart = getCartInfo();
  let arr = localCart.goods_list.goods.filter(item => item.selected !== true);
  if(!arr.length) {
    clearCart(true);
  } else {
    localCart.goods_list.free_try = [];
    localCart.goods_list.goods = arr;
    setCartInfo(localCart);
  }
}

// SEO Mapping
const seoMappings = {
  '255': {
    kw: '抗皱修活御致臻颜霜,希思黎抗皱修活御致臻颜霜,S面霜,希思黎S面霜',
    desc: '希思黎抗皱修活御致臻颜霜“S面霜”，添加三大核心成分CLC胜肽、波斯合欢树精粹和山胡椒精粹，紧致提升，淡纹焕亮，延缓肌肤老化，修活新生。'
  },
  '256': {
    kw: '抗皱修活御致臻颜霜,希思黎抗皱修活御致臻颜霜,S面霜,希思黎S面霜',
    desc: '希思黎抗皱修活御致臻颜霜“S面霜”，添加三大核心成分CLC胜肽、波斯合欢树精粹和山胡椒精粹，紧致提升，淡纹焕亮，延缓肌肤老化，修活新生。'
  },
  '389': {
    kw: '抗皱修活御致臻颜霜,希思黎抗皱修活御致臻颜霜,S面霜,希思黎S面霜',
    desc: '希思黎抗皱修活御致臻颜霜“S面霜”，添加三大核心成分CLC胜肽、波斯合欢树精粹和山胡椒精粹，紧致提升，淡纹焕亮，延缓肌肤老化，修活新生。'
  },
  '223': {
    kw: '抗皱修活御致眼唇霜,希思黎抗皱修活御致眼唇霜,S眼唇霜,希思黎S眼唇霜',
    desc: '希思黎抗皱修活御致眼唇霜“S眼唇霜”，核心成分CLC胜肽、波斯合欢树精粹、山胡椒精粹，减少细纹，重塑眼部轮廓，淡化唇周细纹，有效延缓衰老，调节肌肤生物节律。'
  },
  '257': {
    kw: '抗皱修活精华水,希思黎抗皱修活精华水,S精华水,希思黎S精华水',
    desc: '希思黎抗皱修活精华水“S精华水”，臻选金银杏精粹，深入强韧肌底，为肌肤注入年轻能量，激发肌肤吸收潜能，帮助后续护肤品更好的吸收，持效保湿，强韧肌肤保水屏障，见证肌肤年轻光采。'
  },
  '258': {
    kw: '抗皱修活精华水,希思黎抗皱修活精华水,S精华水,希思黎S精华水',
    desc: '希思黎抗皱修活精华水“S精华水”，臻选金银杏精粹，深入强韧肌底，为肌肤注入年轻能量，激发肌肤吸收潜能，帮助后续护肤品更好的吸收，持效保湿，强韧肌肤保水屏障，见证肌肤年轻光采。'
  }
};
const seoMapping = id => {
  return seoMappings[id] || null;
}

// 页面信息设置：Title & SEO
const setPageInfo = (title, content) => {
  title && (document.title = title);
  let { keywords, description } = content || {};
  let headTag = document.querySelector("head");
  let keyTag = document.querySelector('meta[name="keywords"]');
  let descTag = document.querySelector('meta[name="description"]');
  if (keywords) {
    if (keyTag) {
      keyTag.setAttribute('content', keywords);
    } else {
      let meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = keywords;
      headTag.appendChild(meta);
    }
  } else if (keyTag) {
    if (keyTag.remove) {
      keyTag.remove();
    } else {
      keyTag?.parentElement?.removeChild?.(keyTag);
    }
  }
  if (description) {
    if (descTag) {
      descTag.setAttribute('content', description);
    } else {
      let meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      headTag.appendChild(meta);
    }
  } else if (descTag) {
    if (descTag.remove) {
      descTag.remove();
    } else {
      descTag?.parentElement?.removeChild?.(descTag);
    }
  }
  // document.querySelector('meta[property="og:title"]')
  // document.querySelector('meta[property="og:url"]')
  // document.querySelector('meta[property="og:image"]')
  // document.querySelector('meta[property="og:description"]')
};

// 根据Token判断是否登录
const isLogin = () => hasItem('token');

// 当前页面是否运行在移动端设备浏览器中
const isMobile = () => {
  let regexp = /(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
  return regexp.test(window.navigator.userAgent);
}

// 当前页面是否运行在微信内置浏览器中
const isWXBrowser = () => /micromessenger/i.test(window.navigator.userAgent.toLowerCase());

// 字符串前后拼接
const strPadding = (str, direction, maxLength, fillString) => {
  if (!str || isNaN(maxLength)) return str;
  let nStr = String(str);
  let nFillString = String(fillString);
  if (nStr.length >= maxLength) return str;
  if (nStr.length + nFillString.length > maxLength) {
    nFillString = nFillString.substr(0, maxLength - nStr.length);
  }
  if (direction == "l" || direction == "left" || direction == "start" || direction == "before") {
    return strPadding(nFillString + nStr, direction, maxLength, fillString);
  } else {
    return strPadding(nStr + nFillString, direction, maxLength, fillString);
  }
}

// 日期格式化
const dateFormat = (date, fmt) => {
  if (date?.constructor != Date || fmt?.constructor != String) return "";
  var o = {   
    "M+" : date.getMonth()+1,                 //月份   
    "d+" : date.getDate(),                    //日   
    "h+" : date.getHours(),                   //小时   
    "m+" : date.getMinutes(),                 //分   
    "s+" : date.getSeconds(),                 //秒   
    "q+" : Math.floor((date.getMonth()+3)/3), //季度   
    "S"  : date.getMilliseconds()             //毫秒   
  };   
  if (/(y+)/i.test(fmt))   
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for (var k in o)   
    if(new RegExp("("+ k +")").test(fmt))   
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return fmt;   
}

// 
const isFunction = fn => {
  return typeof fn === "function";
}

// 防抖
function debounce(handle, delay, immediate = false) {
  var timer = null;
  return function () {
    var _this = this, _arg = arguments;
    clearTimeout(timer);
    if (immediate && !timer) {
      handle.apply(_this, _arg);
    }
    timer = setTimeout(function () {
      handle.apply(_this, _arg);
    }, delay);
  }
}

// 节流
function throttle(handle, wait) {
  var lastTime = 0;
  return function () {
    var nowTime = new Date().getTime();
    if (nowTime - lastTime >= wait) {
      handle.apply(this, arguments);
      lastTime = nowTime;
    }
  }
}

// 
function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    } else {
      el = el.parentElement;
    }
  }
  return null;
}

function bdTracker(event, property) {
  if(!window._hmt) return;
  window._hmt.push(['_trackCustomEvent', event, property]);
}


/**
 * 加密(Crypto)
 * @param {string} data
 * @param {string} keyStr KEY
 * @param {string} ivStr  IV
 * @returns
 */
  export const encrypt = (data, keyStr = '3#EDC4sisley$RFV', ivStr = '1!QAZ2sisley@WSX') => {
    const cipher = Crypto.createCipheriv('aes-128-cbc', keyStr, ivStr);
    let encrypted = cipher.update(data, 'utf8', 'binary');
    encrypted = cipher.final('binary');
    encrypted = Buffer.from(encrypted, 'binary').toString('base64');
    return encrypted;
  }

/**
 * 解密(Crypto)
 * @param {string} data
 * @param {string} keyStr KEY
 * @param {string} ivStr  IV
 * @returns
 */
export const decrypt = (data, keyStr = '3edc#EDC4sisleyrfv$RFV', ivStr = '1qaz!QAZ2sisleywsx@WSX') => {
  const cd = Buffer.from(data, 'base64').toString('binary');
  const decipher = Crypto.createDecipheriv('aes-128-cbc', keyStr, ivStr);
  let decrypted = decipher.update(cd, 'binary', 'utf8');
  decrypted += decipher.final('utf8');
  return decrypted;
}



export default {
  // Storage & Cookie
  setItem, getItem, hasItem, removeItem,
  // Cart
  getCartInfo, setCartInfo, addToCart, delCart, updateCart, setCartItemSelected, updateFreeTrialStatus, clearCart,updateOrderCart,
  // Common
  seoMapping, setPageInfo, isLogin, isMobile, isWXBrowser, strPadding, dateFormat, isFunction, debounce, throttle, closest,
  // 
  bdTracker,
  encrypt, decrypt
};